import React, { RefObject, useMemo, useRef } from 'react';
import Table from 'src/components/Table';
import { ITableColumn } from 'src/components/Table/types';
import { ISuite } from 'src/components/SharedTypes';
import { createSuiteTableColumns } from 'src/components/BulkOperations/BulkWalkthroughsSuiteTable/helpers';
import './BulkWalkthroughSuiteTable.scss';

interface BulkWalkthroughsSuiteTableProps {
  suites: ISuite[];
  selectedSuiteIds: string[];
  onSuiteSelect: (suiteId: string) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

const BulkWalkthroughsSuiteTable = ({
  suites,
  selectedSuiteIds,
  onSuiteSelect,
  onSelectAll,
  onDeselectAll,
}: BulkWalkthroughsSuiteTableProps) => {
  const tableRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

  const isAllSelected: boolean =
    suites.length > 0 && selectedSuiteIds.length === suites.length;

  const handleSelectAll = () => {
    if (isAllSelected) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  const columns: ITableColumn[] = useMemo(() => {
    return createSuiteTableColumns({
      allSelected: isAllSelected,
      onSelectAll: handleSelectAll,
      selectedSuiteIds,
      onSuiteSelect,
    });
  }, [isAllSelected, selectedSuiteIds, onSuiteSelect]);

  return (
    <div className="suite-table">
      {suites.length === 0 ? (
        <div className="empty-state">
          <p>No suites available for this property.</p>
        </div>
      ) : (
        <div ref={tableRef}>
          <Table
            applyMinWidth
            defaultSort={{
              accessor: 'number',
              direction: 'ascending',
            }}
            columns={columns}
            data={suites}
            headerTop={undefined}
          />
        </div>
      )}
    </div>
  );
};

export default BulkWalkthroughsSuiteTable;
